import { API } from "../../utility/API"

export const getWithdrawalFee = (currency) => {
    return API.post(`/trading/account/withdraws/estimate_fee?currency=${currency}`)
}

export const getOrderFee = (market_id, price, ord_type, side, volume, actual_volume) => {
    return API.post('trading/market/orders/new/estimate_fee', { market_id, price, ord_type, side, volume, actual_volume })
}

export const getConversionFee = (from_currency, to_currency, amount) => {
    return API.get(`/api/v2/trading/market/conversions/preview?from_currency=${from_currency}&to_currency=${to_currency}&amount=${amount}`)
} 